
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { RmToleranceDto } from "./rm-tolerance.dto";

export class RmToleranceResponse extends GlobalResponseObject{

      data?: RmToleranceDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: RmToleranceDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}